/* eslint-disable */
// Custom validation hook for productAddButtonForm.
// Split into:
// - assets/product-add-validation-rules.js (individual rules)
// - assets/product-add-validation.js (orchestrator + browser hook)

(function (root, factory) {
  if (typeof module !== "undefined" && module.exports) {
    module.exports = factory(require("./product-add-validation-rules.js"));
  } else {
    const rules = root.themeCustomValidationRules;
    const api = factory(rules);
    root.themeCustomValidation = root.themeCustomValidation || {};
    root.themeCustomValidation.validateProductAdd = function (args) {
      const form = args && args.form ? args.form : null;
      const result = api.validate({ document: root.document, form });
      return result.ok;
    };
  }
})(typeof window !== "undefined" ? window : globalThis, function (rules) {
  const defaultRadioSyncConfig = [
    { hiddenSelector: "#properties-stiffness", radioSelector: "input.properties_radio_stiffness" },
    { hiddenSelector: "#properties-riding-style", radioSelector: "input.properties_radio_riding_style" },
    { hiddenSelector: "#properties-return-oem", radioSelector: "input.properties_radio_return_oem" },
    { hiddenSelector: "#properties-fork-parts", radioSelector: "input.properties_radio_fork_parts" },
    { hiddenSelector: "#properties-tour-pack", radioSelector: "input.properties_radio_tour_pack" },
    { hiddenSelector: "#properties-tour-pack-solo", radioSelector: "input.properties_radio_tour_pack_solo" },
  ];

  const requiredSelector =
    ".product-properties input.required-properties:not(:disabled), .product-properties textarea.required-properties:not(:disabled), .product-properties select.required-properties:not(:disabled)";

  const specificFieldErrors = [
    ["#properties-stiffness", "#required_text_stiffness"],
    ["#properties-riding-style", "#required_text_riding_style"],
    ["#properties-return-oem", "#required_text_return_oem"],
    ["#properties-fork-parts", "#required_text_fork_parts"],
    ["#properties-tour-pack", "#required_text_tour_pack"],
    ["#properties-tour-pack-solo", "#required_text_tour_pack_solo"],
  ];

  function scrollToElement(documentRef, target) {
    if (!target) return;
    const doc = documentRef;
    let scrollTarget = target;
    while (
      scrollTarget &&
      doc &&
      doc.body &&
      scrollTarget !== doc.body &&
      scrollTarget.offsetParent === null
    ) {
      scrollTarget = scrollTarget.parentElement || scrollTarget;
    }
    if (scrollTarget && typeof scrollTarget.scrollIntoView === "function") {
      scrollTarget.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  function validate({ document: documentRef, form }) {
    const doc = documentRef;
    if (!doc || typeof doc.querySelectorAll !== "function") return { ok: true };

    const productProperties = doc.querySelectorAll(".product-properties");
    if (!productProperties || !productProperties.length) return { ok: true };

    const formRef = form || null;
    const scope = doc;
    if (rules && typeof rules.syncCustomOrderDataHiddenValues === "function") {
      rules.syncCustomOrderDataHiddenValues(scope, { form: formRef });
    }
    if (rules && typeof rules.syncRadioHiddenValues === "function") {
      rules.syncRadioHiddenValues(scope, defaultRadioSyncConfig, { form: formRef });
    }

    const existingFocused = doc.querySelectorAll(".focused-error");
    existingFocused.forEach((el) => {
      if (el && el.classList) el.classList.remove("focused-error");
    });

    function belongsToForm(el) {
      if (!formRef) return true;
      if (!el) return false;
      try {
        if ("form" in el && el.form) return el.form === formRef;
      } catch (e) {
        // fall through
      }
      return false;
    }

    const requiredInputsRaw = doc.querySelectorAll(requiredSelector);
    const requiredInputs = Array.from(requiredInputsRaw || []).filter(belongsToForm);
    if (!requiredInputs || requiredInputs.length === 0) return { ok: true };

    let hasError = false;
    let firstErrorElement = null;
    let firstErrorScrollTarget = null;

    if (rules && typeof rules.validateRequiredInputs === "function") {
      const result = rules.validateRequiredInputs(requiredInputs, {
        hasFocusedError: () => !!(doc.querySelector && doc.querySelector(".focused-error")),
      });
      if (result && result.hasError) {
        hasError = true;
        firstErrorElement = result.firstErrorElement;
        firstErrorScrollTarget = result.firstErrorScrollTarget;
      }
    }

    if (rules && typeof rules.validateSpecificField === "function") {
      specificFieldErrors.forEach(([selector, errorId]) => {
        const result = rules.validateSpecificField(doc, selector, errorId, { form: formRef });
        if (result && result.hasError) {
          hasError = true;
          if (!firstErrorElement) {
            firstErrorElement = result.firstErrorElement;
            firstErrorScrollTarget = result.firstErrorScrollTarget;
          }
        }
      });
    }

    if (!hasError) return { ok: true };

    if (firstErrorElement) {
      scrollToElement(doc, firstErrorScrollTarget || firstErrorElement);
      try {
        firstErrorElement.focus({ preventScroll: true });
      } catch (e) {
        if (typeof firstErrorElement.focus === "function") {
          firstErrorElement.focus();
        }
      }
    }

    return { ok: false };
  }

  return { validate };
});
